
import React from 'react';
import { FaFilePdf } from 'react-icons/fa6';
import { Container } from 'reactstrap';

const MandatoryDisclosure = () => {
   
    return (

      <>
        
        <div className="container-fluid px-5 mb-3" >
          <h3 className='my-4'>Mandatory Disclosure</h3>

     
          <section className="content py-3" style={{textAlign:'justify' }}>

      
      </section>
        </div>
        </>
    );
};

export default MandatoryDisclosure;
